// donations/spakt.module.js

export const init = () => {
  let attempts = 0;

  // if document.ready needed
  const whenComplete = () => {
    if (++attempts > 30) return;

    if (document.readyState === "complete") {
      let spakt_script = document.createElement("script");
      spakt_script.setAttribute(
        "src",
        "/spenden/jetzt-helfen/file/?component=Customization&ft=js&file=js%2F002%2Fdonation-setup"
      );
      document.head.appendChild(spakt_script);
    } else {
      setTimeout(() => whenComplete(), 400);
    }
  };
  whenComplete();
};
